import React from "react";
import { Row, Col } from "antd";

export function LoginLayout({ children }) {
  /** TODO: Pass styles to sass files */
  const img1 = require("../../../../assets/login-image-entrepreneurs.png");

  const responsiveValues = {
    left: {
      xs: 24,
      sm: 24,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    },
    right: {
      xs: 0,
      sm: 0,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }
  };

  const rightColStyles = {
    height: "100%",
    width: "100%",
    backgroundColor: "rgb(83, 93, 180)",
    backgroundImage: `url(${img1})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  };

  const rowStyle = {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  };

  return (
    <Row
      justify="center"
      align="middle"
      style={rowStyle}>
      <Col
        style={{ padding: "10pt" }}
        {...responsiveValues.left}>
        { children }
      </Col>
      <Col
        style={rightColStyles}
        {...responsiveValues.right}>
      </Col>
    </Row>
  );
}
